import React from 'react';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
    Label
} from 'recharts';
import './StudentGrowthChart.css';
import { FiTrendingUp } from "react-icons/fi";


const data = [
    { month: 'Jan', students: 300 },
    { month: 'Feb', students: 600 },
    { month: 'Mar', students: 750 },
    { month: 'Apr', students: 900 },
    { month: 'May', students: 1100 },
    { month: 'Jun', students: 1150 },
];

const StudentGrowthChart = () => {
    return (
        <div className='chart-wrapper'>
            <div className='chart-title'>
                {/* <FiTrendingUp style={{ marginRight: '8px' }} /> */}
               <span className='decorative-bar'> </span>
                 <h3>Student Growth Over Time</h3>
            </div>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="students" stroke="#007BFF" strokeWidth={3} activeDot={{ r: 8 }} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default StudentGrowthChart;

// LineChart it displays student numbers over Time
// XAxis AND YAxis displays Axis and Label
// Tooltip it shows data on hover
// ResponsiveContainer it makes chart ResponsiveContainer
// stroke="#007BFF" it displays blue line to match dashboard theme